import * as React from 'react';
import { SVGProps } from 'react';

const IconPressureStrokedSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="m14.071 13.485-1.428-1.59a2 2 0 0 1-2.457-2.738L7.382 6.031l.707-.707 3.114 2.84a2 2 0 0 1 2.697 2.46l1.585 1.446-1.414 1.414z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21 10a9.004 9.004 0 0 1-6 8.488V20h2v2H7v-2h2v-1.512A9 9 0 1 1 21 10zm-9 7a7 7 0 1 0 0-14 7 7 0 0 0 0 14z"
    />
  </svg>
);
export default IconPressureStrokedSizeM;
